import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function WhatDid() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/alhussaini/tek-img_05.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={518}
              height={901}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>What Did We Do?</h2>
            <p>
              While implementing a detailed omnichannel strategy, we
              particularly looked over existing architecture (PHP/MySQL) and
              instilled a data synchronization approach that would connect all
              channels seamlessly through a middleware, a connector.
            </p>
            <p>
              TekRevol communicated and understood the insights Al Hussaini
              Trading Company had to offer, we listened and conducted
              comprehensive market research, and eventually proposed additional
              features such as a user wishlist, price match, multilingual
              support, a refund/exchange option, cancellation policies, and a
              detailed vacancy portal for potential employees.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WhatDid;
